import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToConsentDocument,
  mapApiResourceToConsentDocumentDetail,
  mapConsentDocumentPayload,
  type ConsentDocument,
  type ConsentDocumentApiResource,
  type ConsentDocumentDetail,
  type ConsentDocumentDetailApiResource,
  type ConsentDocumentListApiResource,
  type ConsentDocumentWritePayload,
} from './consentDocumentsApi.types';

const CONSENT_DOCUMENTS_PATH = '/me/workspace/consent-documents';

export async function fetchConsentDocuments(): Promise<ConsentDocument[]> {
  const response = await httpClient.get<ConsentDocumentListApiResource>(CONSENT_DOCUMENTS_PATH);
  return response.data.items.map(mapApiResourceToConsentDocument);
}

export async function fetchConsentDocument(documentId: string): Promise<ConsentDocumentDetail> {
  const response = await httpClient.get<ConsentDocumentDetailApiResource>(
    CONSENT_DOCUMENTS_PATH + '/' + documentId
  );
  return mapApiResourceToConsentDocumentDetail(response.data);
}

export async function createConsentDocument(
  payload: ConsentDocumentWritePayload
): Promise<ConsentDocument> {
  const response = await httpClient.post<ConsentDocumentApiResource>(
    CONSENT_DOCUMENTS_PATH,
    mapConsentDocumentPayload(payload)
  );
  return mapApiResourceToConsentDocument(response.data);
}

export async function updateConsentDocument(
  documentId: string,
  payload: ConsentDocumentWritePayload
): Promise<ConsentDocument> {
  const response = await httpClient.put<ConsentDocumentApiResource>(
    CONSENT_DOCUMENTS_PATH + '/' + documentId,
    mapConsentDocumentPayload(payload)
  );
  return mapApiResourceToConsentDocument(response.data);
}

export async function archiveConsentDocument(documentId: string): Promise<void> {
  await httpClient.delete(CONSENT_DOCUMENTS_PATH + '/' + documentId);
}
